import { DS_ALERT_VARIANT, DSAlertVariant } from "@/src/design_system/feedback/alert/types/variant";

export const DS_ALERT_CLASSES = {
  Root: "ds-alert",
  Wrapper: "ds-alert__wrapper",
  IconWrapper: "ds-alert__icon-wrapper",
  Content: "ds-alert__content",
  Header: "ds-alert__header",
  Title: "ds-alert__title",
  Body: "ds-alert__body",
  BodyExpanded: "ds-alert__body--expanded",
  BodySlotted: "ds-alert__body--slotted",
  Footer: "ds-alert__footer",
  Actions: "ds-alert__actions",
  ActionButton: "ds-alert__action-button",
  Toggle: "ds-alert__toggle",
  ToggleButton: "ds-alert__toggle-button",
  CloseButton: "ds-alert__close-button",
} as const;

export const DS_ALERT_VARIANT_CLASS = {
  Info: "ds-alert--info",
  Success: "ds-alert--success",
  Warning: "ds-alert--warning",
  Error: "ds-alert--error",
} as const;

export const DS_ALERT_VARIANT_TO_CLASS_MAP: Record<DSAlertVariant, string> = {
  [DS_ALERT_VARIANT.Info]: DS_ALERT_VARIANT_CLASS.Info,
  [DS_ALERT_VARIANT.Success]: DS_ALERT_VARIANT_CLASS.Success,
  [DS_ALERT_VARIANT.Warning]: DS_ALERT_VARIANT_CLASS.Warning,
  [DS_ALERT_VARIANT.Error]: DS_ALERT_VARIANT_CLASS.Error,
} as const;
